/**
 * Facet Dropdown Component
 * Multi-select dropdown for filtering
 */

import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, Check } from 'lucide-react';

const FacetDropdown = ({ facet, label, options, activeValues = [], onToggle }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isOpen]);

  const count = activeValues.length;

  return (
    <div className="garage-facet-wrap" ref={dropdownRef}>
      <button
        className={`garage-facet-trigger ${count ? 'has-active' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {label}
        {count > 0 && <span className="garage-count-badge">{count}</span>}
        <ChevronDown size={12} />
      </button>
      
      {isOpen && (
        <div className="garage-facet-menu open">
          {options.map((option) => {
            const value = typeof option === 'string' ? option : option.value;
            const optionLabel = typeof option === 'string' ? option : option.label;
            const isChecked = activeValues.includes(value);
            
            return (
              <div
                key={value}
                className={`garage-facet-menu-item ${isChecked ? 'checked' : ''}`}
                onClick={(e) => {
                  e.stopPropagation();
                  onToggle(facet, value);
                }}
              >
                <span className="garage-check">
                  {isChecked && <Check size={12} />}
                </span>
                {optionLabel}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default FacetDropdown;
